import React, {useEffect, useState} from 'react';
import Form from 'react-bootstrap/Form';
import { useStoreActions, useStoreState } from "easy-peasy";
import { withRouter, useParams, useHistory } from 'react-router-dom';


function PreviewCardEdit(props) {
  const savePreviewCard = useStoreActions(actions => actions.preview_cards.savePreviewCard);
  const get_preview_card = useStoreActions(state => state.preview_cards.getPreviewCard);
  const get_preview_cards = useStoreActions(state => state.preview_cards.getPreviewCards);
  const domain = useStoreState(state => state.current_domain);
  const history = useHistory();
  const {card_id} = useParams();
  const [title, setTitle] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [image_url, setImageUrl] = useState("");
  const [cardID, setCardID] = useState("");

  useEffect(() => {
    if (!card_id || card_id === "new") {
      setCardID("");
    } else {
      setCardID(card_id);
    }
    if (cardID && cardID !== "new") {
      console.log("Domain: " + domain.domain + ", card ID: " + cardID);
      get_preview_card({domain: domain.domain, card_id: cardID}).then((card) => {
        setName(card.name);
        setTitle(card.title);
        setDescription(card.description || "");
        if (card.image_url) {
            var now = Date.now();
            setImageUrl(card.image_url + "?c=" + now);
        }
      });
    }
  }, [card_id, get_preview_card, cardID, domain]);

  const onSubmit = (e) => {
    e.preventDefault();
    var form = document.getElementById("editPreviewCard");
    if (!name) {
      alert("You must provide a name for the preview card");
      return;
    }
    if (!title && !description) {
      alert("You must provide a title or description");
      return;
    }
    savePreviewCard(form).then(() => {
       get_preview_cards(domain.domain).then(() => {
          history.push("/preview_cards");
      });
    });
  }

  return (
    <div className="container px-0" id="message_edit">
        <div className="row">
          <div className="col-12">
              <br/>
            <h3>{name || 'Create/Edit Link Preview'}</h3>
          </div>
          <div className="row">
            <div className="col-12">
                <p>Edit/create your preview card for this domain.</p>
            </div>
          </div>
          <div className="col-12">
          <Form id="editPreviewCard" onSubmit={onSubmit}>
            <input type="hidden" name="domain" value={domain.domain}/>
            <input type="hidden" name="id" value={cardID}/>
            { cardID ? (
                <input type="hidden" name="name" value={name}/>
            ): (
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Name: </Form.Label>
                <>
                    <Form.Control type="input" name="name" value={name} onChange={e => setName(e.target.value)}/>
                </>
                <div className="form-text"><em>Note: only Title, Description, and Image fields below will display in Link Preview</em></div>
            </Form.Group>
            )}
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Title: </Form.Label>
                <Form.Control type="input" name="title" value={title || ""} onChange={e => setTitle(e.target.value)}/>
            </Form.Group>
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Description: </Form.Label><br/>
                <Form.Control as="textarea" rows={4} cols={30} name="description" value={description || ""} onChange={e => setDescription(e.target.value)}/>
            </Form.Group>
            <Form.Group className="col-sm-6 mb-3">
                <Form.Label >Image: </Form.Label><br/>
                { image_url && (
                    <><img src={image_url} alt="preview card"/><br/></>
                )}
                <Form.Control type="file" name="image" accept="image/png, image/jpeg, image/gif, image/jpg"/>
                <div className="form-text">Pro Tip: for best results, use image size 1200x630 pixels</div>
            </Form.Group>
            <button type="submit" className="btn btn-primary">Save</button>
          </Form>
          </div>
        </div>
    </div>
  );
}

export default withRouter(PreviewCardEdit);
